import React, { useEffect, useState } from "react";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import * as Yup from "yup";
import { useFormik } from "formik";
import TextInput from "../common/textfield/TextInput";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "../common/Button";
import { failed, success } from "../common/Toastify";
import { resetPassword, userLogin } from "../api/AuthService";
import Lock from '../../assets/images/Lock.png';
import { decryptData } from "../EncryptDecrypt";
import IntservTokenValidation from "../Login/intserv-token-validation";
import { validation, conditionalValidation } from "../../utils/constants";

function ResetPassword() {
    const navigate = useNavigate();
    const { search } = useLocation()
    const [btnLoading, setBtnLoading] = useState(false)
    const [apiTokenValidationModalShow, setApiTokenValidationModalShow] = useState(false)
    const email = new URLSearchParams(search).get("email");
    const verificationCode = new URLSearchParams(search).get("code");
    const expiryTime = new URLSearchParams(search).get("expiry");
    const forgotPasswordToken = new URLSearchParams(search).get("forgotToken");
    const formik = useFormik({
        initialValues: {
            password: "",
            confirmPass: "",
        },
        validationSchema: Yup.object({
            password: conditionalValidation(
                Yup.string()
                    .matches(
                        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#?&~])[A-Za-z\d@$!%*#?&~]{8,}$/, 
                        "Password must be at least 8 characters long, with at least one uppercase letter, one lowercase letter, one number, and one special character (@$!%*#?&~)"
                    ),
                {
                    label: "Password",
                    mandatory: true
                }),
            confirmPass: conditionalValidation(
                Yup.string().oneOf([Yup.ref('password'), null], 'Passwords must match'),
                {
                    label:"Confirm Email",
                    mandatory: true
                })
        }),
        onSubmit: (values) => {
            values.password = values.password?.trim();
            values.confirmPass = values.confirmPass?.trim();
            setBtnLoading(true); 
            const encryptedValues = {
                ...values,
                password:values.password,
                confirmPass:values.confirmPass, 
            }; 
            resetPassword({ ...encryptedValues, email: decryptData(email)?.toLowerCase(), verificationCode: decryptData(verificationCode), forgotPasswordToken: forgotPasswordToken }).then(({ data }) => {
                if (data.status === true) {
                    success(data.message);
                    // Check if user is API user by attempting login with new password
                    const userEmail = decryptData(email)?.toLowerCase();
                    userLogin({ username: userEmail, password: values.password }).then((loginRes) => {
                        if (loginRes?.status === true && loginRes?.user?.["custom:group"] === "API") {
                            setApiTokenValidationModalShow(true);
                        } else {
                            navigate("/");
                        }
                    }).catch(() => {
                        navigate("/");
                    });
                } else {
                    failed(data.error);
                }
            }).catch(res => {
                failed(res?.response?.data?.message || res?.response?.data?.message || res.message);
            }).finally(() => setBtnLoading(false));
        },
    });


    return (
        <>
            <form className="custom-form" onSubmit={formik.handleSubmit}>
                <Row>
                    <Col>
                        <TextInput type="password" icon={Lock} keyField={"password"} label={"New Password"} formik={formik} placeholder={"New Password"} />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <TextInput type="password" icon={Lock} keyField={"confirmPass"} label={"Confirm Password"} formik={formik} placeholder={"Confirm Password"} />
                    </Col>
                </Row>
                <div className="btn-wrap" style={{ display: 'flex' }}>
                    <Button type="submit" isLoading={btnLoading}>Reset</Button>
                </div>
            </form>
            {apiTokenValidationModalShow && <IntservTokenValidation modalShow={apiTokenValidationModalShow} handleClose={() => {
                setApiTokenValidationModalShow(false);
                navigate("/");
            }} />}
        </>
    );
}

export default ResetPassword;